import { Placeholder } from "./Placeholder";
import { useReveal } from "../hooks/useReveal";
import { IMG } from "../lib/images";
import { useLanguage } from "../lib/LanguageContext";

export const About = () => {
  const ref = useReveal();
  const { t } = useLanguage();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-36 bg-[#faf9f6]"
    >
      <div ref={ref} className="reveal max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-end">
          <div className="md:col-span-5">
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#6b705c] mb-6">
              {t("about_eyebrow")}
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-[#0a192f] leading-[1.02]">
              {t("about_title_a")}{" "}
              <em className="italic text-[#1a5b73]">{t("about_title_b")}</em>{" "}
              {t("about_title_c")}
            </h2>
            <p className="mt-8 text-[#4a4a4a] text-base md:text-lg font-light leading-relaxed">
              {t("about_text")}
            </p>
            <div className="mt-10 grid grid-cols-3 gap-6 border-t border-[#0a192f]/10 pt-8">
              <div>
                <div className="font-serif text-3xl md:text-4xl text-[#0a192f]">
                  9.2
                </div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#6b705c] mt-2">
                  {t("about_stat1")}
                </div>
              </div>
              <div>
                <div className="font-serif text-3xl md:text-4xl text-[#0a192f]">
                  900<span className="text-lg">m</span>
                </div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#6b705c] mt-2">
                  {t("about_stat2")}
                </div>
              </div>
              <div>
                <div className="font-serif text-3xl md:text-4xl text-[#0a192f]">
                  10<span className="text-lg">km</span>
                </div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#6b705c] mt-2">
                  {t("about_stat3")}
                </div>
              </div>
            </div>
          </div>

          <div className="md:col-span-7">
            <div className="grid grid-cols-12 gap-4 md:gap-6">
              <Placeholder
                src={IMG.poolPalm}
                alt="Pool, palm tree and villa exterior"
                arch
                className="col-span-7 h-[420px] md:h-[560px]"
                testId="about-image-1"
              />
              <div className="col-span-5 flex flex-col gap-4 md:gap-6">
                <Placeholder
                  src={IMG.balconyMountain}
                  alt="Balcony with mountain view"
                  className="h-[200px] md:h-[270px]"
                  testId="about-image-2"
                />
                <Placeholder
                  src={IMG.bedroomGarden}
                  alt="Bedroom opening to garden"
                  className="h-[200px] md:h-[270px]"
                  testId="about-image-3"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
